// extracted by mini-css-extract-plugin
module.exports = {"pageLinks":"pageLinks__25opU","editIcon":"editIcon__LXWBY","pointsHeader":"pointsHeader__3c7mB","editContainer":"editContainer__138Ec"};